import Calender from "../../assets/calender11.png";
import "../../styles/Card.css";

function Card(props, { arr }) {
   return (
      <div className="career-card">
         <h5 className="helen">{props.name}</h5>
         <span>{props.department}</span>
         <p>
            <div dangerouslySetInnerHTML={{ __html: props.description }} />
         </p>
         <div className="skilles">
            {props.arr.map((skill) => {
               return <span className="skill">{skill}</span>;
            })}
         </div>
         <div className="date">
            <img src={Calender} alt="" />
            <span>
               {arr}
               {props.update}
            </span>
         </div>
      </div>
   );
}

export default Card;
